import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"

/** client: an alternative axios client (the /buy-mls page's link client). */
export function useMlsAddonOffer(client = null) {
  const appAxios = useAuthorizedAxiosClient()
  const axios = client || appAxios
  const [offer, setOffer] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true)
    axios
      .get("/billing/api/mls-addon-offer/")
      .then(({ data }) => {
        setOffer(data)
        setError(null)
      })
      .catch(() => setError("Could not load MLS pricing."))
      .finally(() => setLoading(false))
  }, [axios])

  const purchaseEnabled = Boolean(offer?.purchase_enabled)
  const checkoutReady = Boolean(
    purchaseEnabled && offer?.available && offer?.unit_price != null
  )
  const canCheckout = Boolean(offer?.can_checkout)
  const checkoutBlockedReason = offer?.checkout_blocked_reason || null

  return {
    offer,
    loading,
    error,
    purchaseEnabled,
    checkoutReady,
    canCheckout,
    checkoutBlockedReason,
  }
}
